export default {
    computed: {
        hasDkim() {
            return this.item?.dnsRecords?.dkim?.DkimVerificationStatus == 'Success';
        },
        hasMailFrom() {
            return this.item?.dnsRecords?.mailFromDomain?.MailFromDomainStatus == 'Success';
        },
        hasTrackingDomain() {
            return !!this.item?.dnsRecords?.trackingDomain;
        },
    },
    methods: {
        getDNSRecords() {
            if(this.item.dnsName && this.item.mailFrom) {
                console.debug('Retrieving DNS records...');
                this.loading = true;
                return this.$store.dispatch('domains/getDNSRecords', {}).then(this.updateCapabilities).then(() => {
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                    this.$store.dispatch('ui/notify', { error: true, text: this.$t('mailing.dns.duplicate')});
                });
            } else {
                console.debug('DNS setup is not completed - DNS records were not obtained.');
                return Promise.resolve(true);
            }
        },
        async updateCapabilities() {
            // update capabilities
            let cap = Object.assign({}, this.item.capabilities);
            cap.dkim = this.hasDkim;
            cap.spf = this.hasMailFrom;
            cap.linkDomain = this.hasTrackingDomain;
            // using method from entity-form mixin
            if(this.detectChange(cap, this.item.capabilities)) {
                let fields = { capabilities: cap };
                if(this.item.active == 'INCOMPLETE' && this.canActivate(cap)) {
                    fields.active = 'ACTIVE';
                }
                await this.$store.dispatch('domains/updateFields', { fields });
                // ask for the DNS records again as the updateFields action loads the domain again
                await this.$store.dispatch('domains/getDNSRecords', {});
            }
        },
    }
}